var _path, _path2, _circle, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUserAvatar = function SvgUserAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 34 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#102262",
    d: "M34 17c0 9.389-7.611 17-17 17S0 26.389 0 17 7.611 0 17 0s17 7.611 17 17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M17 32.6c8.616 0 15.6-6.984 15.6-15.6S25.616 1.4 17 1.4 1.4 8.384 1.4 17 8.384 32.6 17 32.6Zm0 1.4c9.389 0 17-7.611 17-17S26.389 0 17 0 0 7.611 0 17s7.611 17 17 17Z",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 5,
    stroke: "#fff",
    strokeWidth: 1.875,
    transform: "matrix(-1 0 0 1 17 17.75)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.875,
    d: "M8.25 29.95c0-.945.594-1.787 1.483-2.105l.206-.073a20.995 20.995 0 0 1 14.122 0l.206.073a2.235 2.235 0 0 1 1.483 2.105.996.996 0 0 1-.456.857C24.22 31.475 21.296 33 17 33s-7.22-1.526-8.294-2.193a.996.996 0 0 1-.456-.857Z"
  })));
};
export default SvgUserAvatar;